import React, { Component } from "react";
import ReactDOM from "react-dom";
import ReactComponent from 'formiojs/components/_classes/component/Component';
import settingsForm from "./HiddenField.settingsForm";

export default class HiddenField extends ReactComponent {

  static get builderInfo() {
    return {
      title: "Hidden Field",
      icon: "minus",
      group: "Data",
      documentation: "",
      weight: -10,
      schema: HiddenField.schema()
    };
  }

  static schema() {
    return ReactComponent.schema({
      type: "hiddenFieldCustomComp",
      hiddenFieldLabel: "",
      colorTheme: "bg-white",
    });
  }

  static editForm = settingsForm;

  render(children) {

    $(".component-edit-container p.lead").html("Hidden Field");

    let hiddenfield_label = "";
    hiddenfield_label += `<span class="comp-label ${this.component.requiredSaveNote ? 'field-required' : ''}">`;
    hiddenfield_label += `${this.component.hiddenFieldLabel || ''}`;
    hiddenfield_label += `</span>`;
    if (this.component.addTooltip && this.component.tooltipDescription){
      hiddenfield_label += ` <i class="fa fa-question-circle text-muted" ref="tooltip" data-title="${this.component.tooltipDescription}"></i>`;
    }

    var hiddenFieldSingleLine = ''
    var attr_json = {
                      id: `${this.component.key}-hiddenFieldSingleLine`,
                      class: `line-input w-100 ${this.component.requiredSaveNote ? 'required' : ''}`,
                      type: 'text'
                    }
    if (this.component.requiredSaveNote){
      attr_json.required = 'required'
    }
    var hiddenFieldSingleLine = this.renderTemplate('input', {

      input: {
        type: 'input',
        ref: `${this.component.key}-hiddenFieldSingleLine`,
        attr: attr_json
      }
    });

    return super.render(`
      <div id="${this.component.key}" class="${this.component.colorTheme}">
        <div>
          ${hiddenfield_label}
        </div>
        <div class="form-group d-none">
          ${hiddenFieldSingleLine}
        </div>
      </div>
    `);
  }


  attach(element) {
    const refs = {};

    refs[`${this.component.key}-hiddenFieldSingleLine`] = '';

    this.loadRefs(element, refs);

    this.addEventListener(this.refs[`${this.component.key}-hiddenFieldSingleLine`][0], 'keyup', () => this.updateValue())
    
    return super.attach(element);
  }

  getValue() {
    var value = '';
    value = this.refs[`${this.component.key}-hiddenFieldSingleLine`][0].value;
    $(`input#${this.component.key}-hiddenFieldSingleLine`).attr("value", value);
    return value;
  }

  setValue(value) {
    this.refs[`${this.component.key}-hiddenFieldSingleLine`][0].value = value;
    $(`input#${this.component.key}-hiddenFieldSingleLine`).attr("value", value);
  }

}
